export default __webpack_public_path__ + "img/507b4aeeed4dedc4034e7955c9e0d043.svg";